var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hidden relative lg:flex mb-16 items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_c('div', {
    staticClass: "px-12 cursor-default w-full"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("\n      " + _vm._s(_vm.moduleName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
  }, [_vm._t("description")], 2), _vm._v(" "), _vm._t("ariane-wire")], 2), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": _vm.illustrationName
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }